import { put } from "redux-saga/effects";
import { setUserLogin } from "../../actions/loginActions";
import fetchAPIServices from "../../../services/fetchAPIServices";
import { loginApi } from "../../../services/endPoints";

export function* handleLogin(action) {
  try {
    if (action && action.payload && action.payload.logout) {
      yield put(setUserLogin({}));
    } else {
      // Check for admin/admin credentials
      if (action.payload.userName === 'AliMohammed2025' && action.payload.passWord === '2025Ali@Mohammed#') {
        // Simulate successful login
        yield put(setUserLogin({ 
          success: true,
          userName: 'admin',
          role: 'ADMIN',
          token: 'dummy-auth-token-12345'
        }));
      } else {
        // Simulate failed login
        yield put(setUserLogin({ 
          success: false,
          message: 'Invalid credentials'
        }));
      }
    }
  } catch (error) {
    console.log(error);
    yield put(setUserLogin({ 
      success: false,
      message: 'Login failed. Please try again.'
    }));
  }
}
